import styled from "styled-components";

export const Input = styled.input`
  height: 40px;
  padding: 0 12px;
  border: 1px solid #C2C8CF;
  border-radius: 8px;

  &:focus {
    outline: none;
    border-color: #DE644E;
  }
`;
